var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadSmiley(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emoji_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.75,20.11a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,51.75,20.11Z",
    fill: "#de7f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V74H74V0ZM22.25,18.85a3.4,3.4,0,1,1-3.4,3.4A3.4,3.4,0,0,1,22.25,18.85ZM53.89,57.44a16.89,16.89,0,0,0-33.78,0H18.85a18.15,18.15,0,0,1,36.3,0ZM51.75,25.65a3.4,3.4,0,1,1,3.4-3.4A3.41,3.41,0,0,1,51.75,25.65Z",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25,24.38a2.14,2.14,0,1,0-2.14-2.13A2.14,2.14,0,0,0,22.25,24.38Z",
    fill: "#de7f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25,25.65a3.4,3.4,0,1,0-3.4-3.4A3.41,3.41,0,0,0,22.25,25.65Zm0-5.54a2.14,2.14,0,1,1-2.14,2.14A2.14,2.14,0,0,1,22.25,20.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75,18.85a3.4,3.4,0,1,0,3.4,3.4A3.4,3.4,0,0,0,51.75,18.85Zm0,5.53a2.14,2.14,0,1,1,2.14-2.13A2.14,2.14,0,0,1,51.75,24.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,39.29A18.17,18.17,0,0,0,18.85,57.44h1.26a16.89,16.89,0,0,1,33.78,0h1.26A18.17,18.17,0,0,0,37,39.29Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSmiley);
export default __webpack_public_path__ + "static/media/sad_smiley.799713f0fe81066df1afe31874f9d577.svg";
export { ForwardRef as ReactComponent };